"use client";
import React, { createContext, useContext, useEffect, useState } from "react";
import { connect, NatsConnection, jwtAuthenticator } from "nats.ws";

interface NatsContextValue {
    connection: NatsConnection | null;
}

const NatsContext = createContext<NatsContextValue>({ connection: null });

// Customize these as needed
const TWENTY_SECONDS = 20_000;
const authenticator = jwtAuthenticator(
    process.env.NEXT_PUBLIC_NATS_JWT!,
    new TextEncoder().encode(process.env.NEXT_PUBLIC_NATS_SEED!)
);

export const NatsProvider = ({ children }: { children: React.ReactNode }) => {
    const [connection, setConnection] = useState<NatsConnection | null>(null);

    useEffect(() => {
        let isMounted = true;
        const doConnect = async () => {
            const nc = await connect({
                servers: process.env.NEXT_PUBLIC_CDC_WEBSOCKET_URL,
                pingInterval: TWENTY_SECONDS,
                authenticator,
            });
            if (isMounted) setConnection(nc);
            else nc.close();
        };
        doConnect().catch((err) => {
            console.error("Failed to connect to NATS:", err);
        });

        return () => {
            isMounted = false;
            if (connection) {
                connection.close();
            }
        };
    }, []);

    return (
        <NatsContext.Provider value={{ connection }}>
            {children}
        </NatsContext.Provider>
    );
};

export function useNatsConnection() {
    return useContext(NatsContext).connection;
}
